module.exports = __webpack_public_path__ + "img/abgc6.e8f08b76.jpg";